export default __webpack_public_path__ + "static/media/signature.2b069b1a.png";